import { Directive, ElementRef, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Directive({
  standalone: false,
  selector: '[appHasRequiredField]'
})
export class HasRequiredFieldDirective {

  constructor(
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<ElementRef>,
  ) { }

  @Input()
  public set appHasRequiredField(abstractControl: AbstractControl) {
    if (abstractControl.validator) {
      const validator = abstractControl.validator({} as AbstractControl);
      if (validator && validator.required) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    } else {
      this.viewContainer.clear();
    }
  }
}
